/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Center, Divider, Drawer, Group, Image, Space, Stack, Text, UnstyledButton } from "@mantine/core";
import { IconArrowRight, IconCheck, IconMenu2, IconX, IconUserCircle } from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks/hooks";
import './NavbarStyle.css';
import { clearRefinementList, resetSortByIndex, setProductSearchQuery } from "../../redux/features/productSearchCache/productSearchCache";
import { useDisclosure } from "@mantine/hooks";
import MethodMaterialsLogo_NoBackground from '../../assets/mmLogo_NoBackgroundFinal.png'

/* Handlers */
export const handleSearch = (
    localSearchQuery : string,
    navigate : any,
    dispatch : any
) => {
    // 1) Set our productSearch Query
    dispatch(setProductSearchQuery(localSearchQuery));
    // 2) Clear RefinementList
    dispatch(clearRefinementList());
    // 3) Reset sortByIndex
    dispatch(resetSortByIndex());
    // 4) Navigate to the search list page
    navigate(`/search-products-list?${import.meta.env.VITE_ALGOLIA_MAIN_INDEX}[query]=${encodeURIComponent(localSearchQuery)}`);
}

export const Navbar = (props : {
    showSearchBar : boolean
}) : JSX.Element => {
    
    /* Local State */
    const navigate = useNavigate();
    const location = useLocation();
    const currentUser = useAppSelector((state : any) => state.currentUser.currentUser)

    /* Navigation Drawer State */
    const [opened, { open, close }] = useDisclosure(false);

    const handleJoinNow = () => {
        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            navigate('/', { state: { scrollToTop: true } });
        }
    };

    return(
        <>
            {/* Mobile Format */}
            <Box hiddenFrom="md">
                <Box p={"1em"} style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center' }}>
                    <Box>
                        <UnstyledButton onClick={() => {open();}}>
                            <IconMenu2 color={"#5d636f"} size={"3em"}/>
                        </UnstyledButton>
                    </Box>
                    <UnstyledButton onClick={() => {navigate('/')}}>
                        <Image src={MethodMaterialsLogo_NoBackground} h={"5em"} w={"5em"}/>
                    </UnstyledButton>
                    <Box />
                </Box>
                <Divider />
            </Box>
            {/* Desktop Format*/}
            <Box style={{position: 'sticky', top: '0', zIndex: '1000', backgroundColor: 'rgba(255, 255, 255, 0.5)', backdropFilter: 'blur(10px)'}} visibleFrom="md">
                <Group p={"1em"} justify={"space-between"} pl={'4em'} pr={'4em'}>
                        <UnstyledButton onClick={() => {navigate('/')}}>
                            <Image src={MethodMaterialsLogo_NoBackground} h={"5em"} w={"5em"}/>
                        </UnstyledButton>
                        <Box pl={'4em'}>
                            <Button c={'#5d636f'} variant={'transparent'} onClick={() => {
                                navigate('/')
                            }}>Home</Button>
                            <Button c={'#5d636f'} variant={'transparent'} onClick={() => {
                                navigate('/about')
                            }}>About</Button>
                            <Button c={'#5d636f'} variant={'transparent'} onClick={() => {
                                navigate('/member-benefits')
                            }}>Member Benefits</Button>
                            <Button c={'#5d636f'} variant={'transparent'} onClick={() => {
                                navigate('/contact')
                            }}>Contact</Button>
                        </Box>
                    <Group>
                        {
                            (currentUser !== null) &&
                            <Stack align={"center"} gap={"xs"}>
                                <UnstyledButton onClick={() => { navigate('/profile') }}>
                                    <div className={"logged-in-profile-desktop"}>
                                        <IconCheck stroke={4} color={'#cc7800'}/>
                                    </div>
                                    <Center>
                                        <Group>
                                            <IconUserCircle color={"#5d636f"} />
                                            <Text c={'#5d636f'} fz={14}>Profile</Text>
                                        </Group>
                                    </Center>
                                </UnstyledButton>
                            </Stack>
                        }
                        <Button
                            color="#cc7800"
                            rightSection={<IconArrowRight size={16} />}
                            radius="md"
                            onClick={handleJoinNow}
                        >
                            Join Now
                        </Button>
                        <Space w={'0.5em'} />
                        <Stack align={"center"} gap={"xs"} >
                            {/* <UnstyledButton onClick={() => {navigate('/cart')}}>
                                {
                                    (cartState.length != 0) ?
                                        <div className={"cart-counter-mobile"}>
                                            <Text fw={"bold"} c={"white"} fz={12}>{cartState.reduce((a : number, b : CartProduct) => +a + +b.quantity, 0)}</Text>
                                        </div>
                                    :
                                        <></>
                                }
                                <Center>
                                    <IconShoppingCart color={"#5d636f"} size={"2.5em"}/>
                                </Center>
                            </UnstyledButton> */}
                        </Stack>
                    </Group>
                </Group>
                <Divider />
            </Box>
            {/* Mobile Navigation Drawer*/}
            <Drawer 
                opened={opened} 
                onClose={close} 
                size={'80%'} 
                withCloseButton={false}
                styles={{
                    content: {
                        backgroundColor: '#F7F7F7'
                    }
                }}
            >
                <Group justify={'flex-end'}>
                    <UnstyledButton onClick={() => {close();}}>
                        <IconX color={'#5d636f'}/>
                    </UnstyledButton>
                </Group>
                <Space h={'1em'} />
                <UnstyledButton onClick={() => {navigate('/')}}>
                    <Text c={'#5d636f'} fz={24}>Home</Text>
                </UnstyledButton>
                <Space h={'1em'} />
                {/* {
                    (currentUser !== null) &&
                    <>
                        <UnstyledButton onClick={() => { navigate('/profile') }}>
                            <Text c={'#5d636f'} fz={24}>Profile</Text>
                        </UnstyledButton>
                        <Space h={'1em'} />
                    </>
                } */}
                <UnstyledButton onClick={() => {navigate('/about')}}>
                    <Text c={'#5d636f'} fz={24}>About</Text>
                </UnstyledButton>
                <Space h={'1em'} />
                <UnstyledButton onClick={() => {navigate('/member-benefits')}}>
                    <Text c={'#5d636f'} fz={24}>Member Benefits</Text>
                </UnstyledButton>
                <Space h={'1em'} />
                <UnstyledButton onClick={() => {navigate('/contact')}}>
                    <Text c={'#5d636f'} fz={24}>Contact</Text>
                </UnstyledButton>
                <Space h={'1.5em'} />
                <Button
                    color="#cc7800"
                    size="lg"
                    rightSection={<IconArrowRight />}
                    radius="md"
                    onClick={() => { close(); handleJoinNow(); }}
                    fullWidth
                >
                    Join Now
                </Button>
                {/* <UnstyledButton onClick={() => {
                    (currentUser !== null) ? navigate('/your-orders') : navigate('/login')
                }}>
                    <Text c={'#5d636f'} fw={'bold'} fz={24}>Your Orders</Text>
                </UnstyledButton> */}
            </Drawer>
        </>
    );
}
